(() => {
  function initialize(root) {
    if (root.dataset.galleryInitialized) return;
    root.dataset.galleryInitialized = 'true';
    const gallery = root.querySelector('[data-product-gallery]');
    const track = gallery.querySelector('[data-gallery-track]');
    const slides = [...track.querySelectorAll('[data-gallery-media]')];
    const buttons = [...gallery.querySelectorAll('[data-gallery-target]')];
    const status = gallery.querySelector('[data-gallery-status]');
    let current = -1, frame;
    const setActive = index => {
      if (index < 0 || current === index) return;
      current = index;
      buttons.forEach(button => { button.setAttribute('aria-current', String(button.dataset.galleryTarget === slides[index].dataset.galleryMedia)); });
      slides.forEach((slide, i) => {
        slide.querySelectorAll('video').forEach(video => { if (i !== index) video.pause(); });
        slide.querySelectorAll('iframe').forEach(iframe => {
          iframe.tabIndex = i === index ? 0 : -1;
          if (i !== index) {
            // Pause supported players without navigating/reloading them.
            const url = new URL(iframe.src, location.href);
            if (url.hostname.endsWith('youtube.com')) iframe.contentWindow?.postMessage(JSON.stringify({event:'command',func:'pauseVideo',args:[]}),url.origin);
            if (url.hostname.endsWith('vimeo.com')) iframe.contentWindow?.postMessage({method:'pause'},url.origin);
          }
        });
      });
      const selected = buttons.find(button => button.dataset.galleryTarget === slides[index].dataset.galleryMedia);
      if (selected) {
        const rail = selected.parentElement;
        const r = rail.getBoundingClientRect(), b = selected.getBoundingClientRect();
        if (b.top < r.top || b.bottom > r.bottom) rail.scrollTop += b.top-r.top;
        if (b.left < r.left || b.right > r.right) rail.scrollLeft += b.left-r.left;
      }
      status.textContent = `Media ${index + 1} of ${slides.length}`;
      const slideH = slides[index].getBoundingClientRect().height;
      if (slideH > 0) track.style.height = `${slideH}px`;
    };
    const goTo = id => {
      const index = slides.findIndex(slide => slide.dataset.galleryMedia === String(id));
      if (index < 0) return;
      track.scrollLeft += slides[index].getBoundingClientRect().left - track.getBoundingClientRect().left;
      setActive(index);
    };
    buttons.forEach(button => button.addEventListener('click', () => goTo(button.dataset.galleryTarget)));
    track.addEventListener('keydown', event => {
      if (event.target !== track || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      event.preventDefault();
      const index = event.key === 'Home' ? 0 : event.key === 'End' ? slides.length-1 : Math.max(0,Math.min(slides.length-1,current+(event.key === 'ArrowRight' ? 1 : -1)));
      if (slides[index]) goTo(slides[index].dataset.galleryMedia);
    });
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const edge = track.getBoundingClientRect().left;
        let nearest = -1, distance = Infinity;
        slides.forEach((slide,index) => { const delta = Math.abs(slide.getBoundingClientRect().left-edge); if (delta < distance) { nearest=index; distance=delta; } });
        setActive(nearest);
      });
    }, {passive:true});
    const resize = new ResizeObserver(() => {
      if (current >= 0) track.style.height = `${slides[current].getBoundingClientRect().height}px`;
    });
    slides.forEach(slide => resize.observe(slide));
    root.addEventListener('product:variant-media', event => goTo(event.detail.mediaId || gallery.dataset.initialMedia));
    root.querySelectorAll('.pdp-information details').forEach(details => {
      const summary = details.querySelector('summary');
      summary.setAttribute('aria-expanded', String(details.open));
      details.addEventListener('toggle', () => summary.setAttribute('aria-expanded', String(details.open)));
    });
    goTo(gallery.dataset.initialMedia);
    root.galleryCleanup = () => { resize.disconnect(); cancelAnimationFrame(frame); };
  }
  document.querySelectorAll('[data-product-purchase]').forEach(initialize);
  document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('[data-product-purchase]').forEach(initialize));
  document.addEventListener('shopify:section:unload',event => event.target.querySelectorAll('[data-product-purchase]').forEach(root => root.galleryCleanup?.()));
})();
